// Version : 0.0.1
// Author : VISHAL BHARATHI
// CREATED DATA: 18-09-2025

const TransferFunderActionTypes = {
	/** ***************** UPDATE GOLD CLOSE DETAILS START *********************** */
	UPDATE_TRANSFER_FUNDER_DETAILS_START: 'update_transfer_funder_details_start',
	UPDATE_TRANSFER_FUNDER_DETAILS_SUCCESS: 'update_transfer_funder_details_success',
	UPDATE_TRANSFER_FUNDER_DETAILS_FAILURE: 'update_transfer_funder_details_failure',
	UPDATE_TRANSFER_FUNDER_DETAILS_RESPONSE_RESET: 'update_transfer_funder_details_response_reset',
	UPDATE_TRANSFER_FUNDER_DETAILS_RESPONSE_CHANGED:
		'update_transfer_funder_details_response_changed',
	/** ***************** UPDATE GOLD CLOSE DETAILS END *********************** */

	/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP START *********************** */
	FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_START: 'fetch_all_loan_index_list_for_group_start',
	FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_SUCCESS: 'fetch_all_loan_index_list_for_group_success',
	FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_FAILURE: 'fetch_all_loan_index_list_for_group_failure',
	FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_RESPONSE_RESET:
		'fetch_all_loan_index_list_for_group_response_reset',
	FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_RESPONSE_CHANGED:
		'fetch_all_loan_index_list_for_group_response_changed',
	/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP END *********************** */
};
export default TransferFunderActionTypes;
